export default __webpack_public_path__ + "static/media/bed08.a2d64fb4.png";